/**
 * Marketplace Routes
 */

import type { RouteObject } from "react-router-dom";
import { ProtectedRoute } from "@/components/layout/protected-route";
import { BrowseContractorsPage } from "./pages/browse-contractors";
import { BrowseDesignersPage } from "./pages/browse-designers";
import { ContractorDetailPage } from "./pages/contractor-detail";
import { DesignerDetailPage } from "./pages/designer-detail";
import { InvitationDetailPage } from "./pages/invitation-detail";
import { MyAssignmentsPage } from "./pages/my-assignments";
import { OpportunitiesPage } from "./pages/opportunities";

export const marketplaceRoutes: RouteObject[] = [
	{
		path: "/designers",
		element: (
			<ProtectedRoute requireUserType>
				<BrowseDesignersPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/designers/:id",
		element: (
			<ProtectedRoute requireUserType>
				<DesignerDetailPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/contractors",
		element: (
			<ProtectedRoute requireUserType>
				<BrowseContractorsPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/contractors/:id",
		element: (
			<ProtectedRoute requireUserType>
				<ContractorDetailPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/opportunities",
		element: (
			<ProtectedRoute requireUserType="contractor">
				<OpportunitiesPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/assignments",
		element: (
			<ProtectedRoute requireUserType="contractor">
				<MyAssignmentsPage />
			</ProtectedRoute>
		),
	},
	{
		path: "/invitations/:id",
		element: (
			<ProtectedRoute requireUserType="contractor">
				<InvitationDetailPage />
			</ProtectedRoute>
		),
	},
];
